(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hotspots"] && !Shopify.designMode) return;
  try {
    
  /**
   * Pause-on-hover for hotspot slideshow
   * When user hovers over the slideshow (to interact with hotspot dots),
   * autoplay is paused. It resumes when the mouse leaves.
   */
  (function () {
    document.querySelectorAll('slideshow-component[pause-on-hover][autoplay]').forEach(function (slideshow) {
      let wasPaused = false;

      slideshow.addEventListener('mouseenter', function () {
        wasPaused = slideshow.hasAttribute('paused');
        if (!wasPaused && slideshow.pause) {
          slideshow.pause();
        }
      });

      slideshow.addEventListener('mouseleave', function () {
        if (!wasPaused && slideshow.play) {
          slideshow.play();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
